<template>
  <div class="p-4 max-w-3xl mx-auto">
    <div class="row border rounded d-flex align-items-center">
      <div class="col">
        <input
          type="file"
          @change="handleFileUpload"
          accept=".xlsx, .xls"
          class="btn btn-primary btn-sm"
        />
      </div>
      <div class="col">
        <div class="dropdown">
          <button
            class="btn btn-primary dropdown-toggle btn-sm"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <span v-if="!selected_pool">Select pool...</span>
            <span v-else>{{ selected_pool_name }}</span>
          </button>
          <ul class="dropdown-menu">
            <li
              class="dropdown-item"
              v-for="t in all_pools"
              :key="t.id"
              @click="selectPool(t.name, t.id)"
            >
              {{ t.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <button class="btn btn-success btn-sm p-2 float-end" v-if="rows.length">
      Add all
    </button>
    <div class="row" v-if="msg || err.length">
      <div class="col border rounded bg-warning">
        <div v-if="msg">{{ msg }}</div>
        <ul class="list-group" v-if="err.length">
          <li class="list-group-item" v-for="e in err" :key="e">{{ e }}</li>
        </ul>
      </div>
    </div>
    <div v-if="rows.length" class="mt-6 p-2 d-flex justify-content-center">
      <table
        class="table-auto w-full border-collapse border border-gray-300 text-center"
      >
        <thead>
          <tr>
            <th
              v-for="(col, index) in columns"
              :key="index"
              class="border px-2 py-1 bg-gray-200 text-left"
            >
              {{ col }}
            </th>
            <th class="border px-2 py-1 bg-gray-200"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, rowIndex) in rows"
            :key="rowIndex"
            class="hover-blue"
          >
            <td v-for="col in columns" :key="col" class="border px-2 py-1">
              {{ row[col] }}
            </td>
            <td
              class="border px-2 py-1 text-red-500 text-center cursor-pointer"
              @click="removeRow(rowIndex)"
            >
              ❌
            </td>
            <td>
              <button
                class="btn btn-sm btn-success tinybtn"
                @click="addPlayer(row, rowIndex)"
              >
                Add
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as XLSX from "xlsx";
import { useStore } from "@/store/index";
import supabase from "@/supabase/config";
const store = useStore();
const rows = ref([]);
const columns = ref([]);
const err = ref([]);
const msg = ref("");
const all_pools = ref([]);
const selected_pool = ref("");
const selected_pool_name = ref("");
const selectPool = (pool_name, pool_id) => {
  if (selected_pool.value != pool_id) {
    selected_pool.value = pool_id;
    selected_pool_name.value = pool_name;
  } else {
    selected_pool.value = "";
    selected_pool_name.value = "";
  }
};
onMounted(() => {
  setTimeout(() => {
    fetchPools();
  }, 1000);
});
const fetchPools = async () => {
  let { data: pools, error } = await supabase
    .from("pools")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_pools.value = pools;
};
function handleFileUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: "array" });

    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const jsonData = XLSX.utils.sheet_to_json(worksheet);

    rows.value = jsonData;
    columns.value = jsonData.length ? Object.keys(jsonData[0]) : [];
  };
  reader.readAsArrayBuffer(file);
}

function removeRow(index) {
  rows.value.splice(index, 1);
}

const addPlayer = async (data, index) => {
  //console.log(data);
  var entries = Object.entries(data);
  var name = entries[0][1];
  var stats = entries.slice(1);
  var strs = [];
  stats.forEach((s) => {
    strs.push(s[0] + " : " + s[1]);
  });
  console.log(name, strs);
  var playerObj = {
    auction_id: store.live_auction,
    name: name,
    stats: strs,
  };
  if (selected_pool.value) {
    playerObj.pool_id = selected_pool.value;
  }
  if (!err.value.length) {
    const { data, error } = await supabase
      .from("players")
      .insert([playerObj])
      .select();
    if (error) {
      err.value.push(error.message);
      setTimeout(() => {
        err.value = [];
      }, 1000);
    } else {
      msg.value = "Player " + name + " added!";
      setTimeout(() => {
        msg.value = "";
      }, 1000);
      removeRow(index);
    }
  }
};
function objectToArrayOfObjects(obj) {
  return Object.entries(obj).map(([key, value]) => ({ [key]: value }));
}
</script>

<style scoped>
table {
  font-family: Arial, sans-serif;
}
.tinybtn {
  padding: 1px;
}
.hover-blue:hover {
  background-color: #d6f0ff; /* pastel light blue */
}
</style>
